<style lang="scss" scoped>
.workspace-page {
  overflow-y: auto;
  overflow-x: hidden;

  .d-contents {
    display: contents;
  }

  &::-webkit-scrollbar {
    width: 14px;
    height: 18px;
  }
  &::-webkit-scrollbar-thumb {
    height: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 7px;
    background-color: rgba(0, 0, 0, 0.1);
    box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
  }
  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
}
.filter-bar {
  background: #fff;
  z-index: 1;
  border-bottom: 1px solid #e1e9ed;
  padding: 10px 0;
}
</style>
<template>
  <div>

    <keep-alive>
      <navbar />
    </keep-alive>

    <sub-navbar v-if="!hideHeader">
      <template v-slot:breadcrumbs>
        <slot name="breadcrumbs"></slot>
      </template>

      <template v-slot:actions>
        <slot name="actions"></slot>
      </template>
    </sub-navbar>

    <header v-if="hasFiltersSlot" class="filter-bar row">
      <div class="container">
        <slot name="filters"></slot>
      </div>
    </header>

    <div class="workspace-page row position-relative" :style="{ height: `calc(var(--vh, 1vh) * 100 - ${header_height}px)` }">
      <div :class="[container]">
        <slot name="page"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/general/navbar';
import Trialbar from '@/components/general/trialbar';
import SubNavbar from '@/components/general/sub-navbar';

export default {
  name: 'workspace-layout',

  components: { SubNavbar, Navbar, Trialbar },

  props: {
    hideHeader: {
      default: false,
    },
    container: {
      type: String,
      required: false,
      default: 'container',
    },
  },

  data: () => ({
    header_height: 0,
  }),

  mounted() {
    document.querySelectorAll('header').forEach(e => {
      this.header_height += e.offsetHeight;
    });
    if (this.header_height === 190) {
      document.querySelector('body').classList.add('has-trial');
    }
  },

  computed: {
    hasFiltersSlot() {
      return !!this.$slots.filters;
    },
  },
};
</script>
